import { useState } from 'react';
import { showSuccess, showError } from '@utils';

const SUBMITTING_JOB_MESSAGE_SUCCESS = 'Successfully submitted job';

const SUBMITTING_JOB_MESSAGE_ERROR = 'Failed to submit job';

export const useExportAsyncFile = (onExportRequest) => {
  const [exporting, setExporting] = useState(false);

  const handleExportAsyncFile = async () => {
    try {
      setExporting(true);
      await onExportRequest?.();

      showSuccess(SUBMITTING_JOB_MESSAGE_SUCCESS);
    } catch (error) {
      showError(SUBMITTING_JOB_MESSAGE_ERROR);
    } finally {
      setExporting(false);
    }
  };

  return {
    exporting,
    handleExportAsyncFile,
  };
};
